export default __webpack_public_path__ + "static/media/syncteraLogo.538f35ff.png";